export default __webpack_public_path__ + "static/media/hero2026.4172e97a.jpg";